module.exports = __webpack_public_path__ + "img/steering-wheel.93da9ee8.svg";